export default "__VITE_ASSET__Bdzj3XXX__"